module.exports = __webpack_public_path__ + "static/media/linear-sawtooth-lateral-4.841b7ad8.png";